export default __webpack_public_path__ + "static/media/Flat_Yellow.d783a081.png";